import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: underline;
`;

export const Text = styled.p`
  font-weight: ${props => (props.bold ? '600' : props.fontWeight || '400')};
  font-size: 16px;
  display: inline;
  letter-spacing: -0.2px;
  color: ${props => props.color};
`;

export const OrderHistoryMain = styled.div`
  padding: 1rem;
  margin-top: 2rem;
  border: 1px solid #d8d8d8;
`;

export const OrderHistoryDataMain = styled.div`
  display: flex;
  padding: 0.25rem 0;
`;

export const OrderHistoryTimestamp = styled.div`
  margin-right: 5rem;
  color: #71757b;
  font-size: 14px;
  font-weight: 700;
`;

export const OrderHistoryAction = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

export const FieldWrapper = styled.div`
  margin: 1em 0;
`;
export const ConfirmationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  border: 1px solid #aaaaaa;
  padding: 1rem;
  background: #f2eff4;
`;

export const ConfirmationMessage = styled.div`
  max-width: 50%;
  font-weight: 700;
  background-color: transparent;
`;

export const AttachmentContainer = styled.div`
  display: flex;
  border: 1px solid #e2e2e2;
  padding: 12px 14px;
  justify-content: space-between;
`;

export const FieldTitle = styled.h3`
  font-weight: bold;
  color: #000;
`;

export const customStyles = `
  overflow: scroll;
  max-height: 80% !important;
  height:83%;
  width: 67%;
  position: fixed;
  margin-left: 17%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;
  text-align:left;`;